export const SET_UPRISM_STATE = "SET_UPRISM_STATE";

export const SET_CHAT = "SET_CHAT";

export const SET_CHAT_OPEN = "SET_CHAT_OPEN";
